export enum CAT_SCREEN_LIST {

}

export enum CAT_REQUEST_ID_LIST {
  GET_CAT = 'GET_CAT',
  GET_FULL_CAT = 'GET_FULL_CAT',
  POST_CAT = 'POST_CAT',
  PATCH_CAT = 'PATCH_CAT',
  DELETE_CAT = 'DELETE_CAT',
  CALL_FOOD_CATEGORY = 'CALL_FOOD_CATEGORY',
  UPDATE_CATEGORY_SEQUENCE = 'UPDATE_CATEGORY_SEQUENCE',
  GET_MENU_IN_CAT = 'GET_MENU_IN_CAT',
  SORT_MENU_SEQUENCE = 'SORT_MENU_SEQUENCE',
}

export enum CAT_TRANSLATION_KEY {
  MENU_CATEGORY_NAME_TH_DUP = 'menuCategoryName_is_duplicated',
  MENU_CATEGORY_NAME_EN_DUP = 'menuCategoryNameEN_is_duplicated',
}

export enum CAT_INLINE_ERROR {
  MENU_CATEGORY_NAME_DUP = 'ชื่อหมวดหมู่ซ้ำ กรุณาตั้งชื่อใหม่',
}
